// extracted by mini-css-extract-plugin
module.exports = {"container":"UfAzt","nav":"b1uwv","content":"lIqqD","route":"CGIFZ"};